export default __webpack_public_path__ + "static/media/factory.53f114ef.webp";